/**
 * Frogames Custom Wishlist
 * Usa Customer Metafields di Shopify + Cloudflare Worker
 */

(function () {
  'use strict';

  var WORKER_URL = 'https://shy-sea-ce07-frogames-wishlist.info-frogames.workers.dev';

  // ============================================================
  // STATO
  // ============================================================
  var state = {
    customerId: window.__wishlist ? window.__wishlist.customerId : null,
    items: window.__wishlist ? window.__wishlist.items.map(String) : [],
    loading: false
  };

  function isInWishlist(pid) { return state.items.includes(String(pid)); }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      if (isInWishlist(pid)) {
        btn.classList.add('wishlist-added');
        btn.setAttribute('aria-label', 'Rimuovi dalla Wishlist');
        if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', 'true');
      } else {
        btn.classList.remove('wishlist-added');
        btn.setAttribute('aria-label', 'Salva in Wishlist');
        if (btn.hasAttribute('aria-pressed')) btn.setAttribute('aria-pressed', 'false');
      }
    });
  }

  function updateCounter() {
    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      var count = state.items.length;
      el.textContent = count;
      count > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', '');
    });
  }

  function updateUI() { updateAllButtons(); updateCounter(); }

  // Ponte globale per componenti esterni (es. section frog-most-wanted):
  // permette di sapere se un prodotto e in wishlist e di riallineare i cuori
  // delle card create dinamicamente dopo wishlist.js.
  window.FrogWishlist = {
    has: function(id) { return isInWishlist(id); },
    refreshButtons: function() { updateAllButtons(); },
    // Usata da «Sposta in wishlist» nel carrello (5 set 2026): stessa
    // logica del cuore sulle schede, ma torna una promessa e per chi non
    // e' loggato mostra l'invito invece di rimandare al login.
    aggiungi: function(id) {
      if (!state.customerId) { showWishlistLoginPrompt(); return Promise.reject('not_logged_in'); }
      if (isInWishlist(id)) return Promise.resolve('gia');
      state.items.push(String(id));
      updateUI();
      return apiCall('add', id, 'La mia lista');
    }
  };

  // ============================================================
  // API
  // ============================================================
  function apiCall(action, productId, listName) {
    if (!state.customerId) { window.location.href = '/account/login'; return Promise.reject('not_logged_in'); }

    var body = { action: action, customerId: String(state.customerId), productId: String(productId) };
    if (listName) body.listName = listName;

    return fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (res) { return res.json(); })
    .then(function (data) {
      if (data.error) {
        if (data.error.indexOf('128') !== -1) {
          showWlToast('Wishlist piena! Rimuovi qualche gioco per aggiungerne altri (max 128)');
          // Ripristina stato locale
          if (action === 'add') {
            state.items = state.items.filter(function(id) { return id !== String(productId); });
            updateUI();
          }
        } else {
          console.error('[Wishlist] API error:', data.error);
        }
        throw new Error(data.error);
      }
      if (data.wishlist) state.items = data.wishlist.map(String);
      updateUI();
      return data;
    })
    .catch(function (err) { console.error('[Wishlist]', err); throw err; });
  }

  // ============================================================
  // CLICK HANDLER (cuore)
  // ============================================================
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();

    var productId = btn.getAttribute('data-product-id');
    if (!productId) return;

    // Se non loggato, mostra mini popup di invito
    if (!state.customerId) {
      btn.style.transform = 'scale(1.2)';
      setTimeout(function() { btn.style.transform = ''; }, 200);
      showWishlistLoginPrompt();
      return;
    }

    var wasIn = isInWishlist(productId);

    // Se sta aggiungendo e ha più liste, chiedi in quale lista (solo nella pagina wishlist)
    if (!wasIn && document.getElementById('wishlistPage')) {
      var pageData = window.__wishlistPage;
      if (pageData && pageData.wishlistData && pageData.wishlistData.lists && pageData.wishlistData.lists.length > 1) {
        showAddToListModal(productId);
        return;
      }
    }

    // Default: sempre in "La mia lista"
    var defaultListName = 'La mia lista';

    // Optimistic UI
    if (wasIn) {
      state.items = state.items.filter(function (id) { return id !== String(productId); });
    } else {
      state.items.push(String(productId));
    }
    updateUI();

    apiCall(wasIn ? 'remove' : 'add', productId, wasIn ? null : defaultListName).then(function() {
      if (wasIn) {
        // Rimuovi card dalla griglia
        var card = document.querySelector('[data-wl-card][data-product-id="' + productId + '"]');
        if (card) {
          card.style.transition = 'opacity .3s, transform .3s';
          card.style.opacity = '0';
          card.style.transform = 'scale(.95)';
          setTimeout(function() { card.remove(); updateWishlistPageCount(); }, 300);
        }
      } else {
        // Aggiungi card alla griglia in tempo reale se siamo sulla pagina wishlist
        var grid = document.getElementById('wlGrid');
        if (grid && !document.querySelector('[data-wl-card][data-product-id="' + productId + '"]')) {
          // Cerca info prodotto dal btn o dal trending data
          var btn = document.querySelector('[data-wishlist-btn][data-product-id="' + productId + '"]');
          var trendingCard = btn ? btn.closest('.wl-card') : null;

          if (trendingCard) {
            // Clona la card dal trending e adattala per la griglia wishlist
            var imgEl = trendingCard.querySelector('.wl-card__media img');
            var titleEl = trendingCard.querySelector('.wl-card__title');
            var handle = '';
            var titleLink = trendingCard.querySelector('a.wl-card__media');
            if (titleLink) handle = titleLink.getAttribute('href').replace('/products/', '');

            var newCard = document.createElement('div');
            newCard.className = 'wl-card';
            newCard.setAttribute('data-wl-card', '');
            newCard.setAttribute('data-product-id', productId);
            newCard.setAttribute('data-product-title', titleEl ? titleEl.textContent : '');
            newCard.setAttribute('data-product-price', '0');
            newCard.setAttribute('data-product-available', 'true');
            newCard.setAttribute('data-product-deal', '0');

            var cardHtml = '';
            cardHtml += '<div class="wl-card__checkbox" onclick="toggleSelectCard(event, \'' + productId + '\', \'\')"></div>';
            cardHtml += '<div class="wl-card__badges"></div>';
            cardHtml += '<div class="wl-card__actions-top"><button class="wl-card__action-btn" onclick="openCardMenu(event, \'' + productId + '\')"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg></button><div class="wl-card__menu" id="menu-' + productId + '"><button onclick="moveToList(\'' + productId + '\')">Sposta in altra lista</button><button onclick="removeFromWishlist(\'' + productId + '\')">Rimuovi</button></div></div>';
            cardHtml += '<a href="/products/' + handle + '" class="wl-card__media">';
            if (imgEl) cardHtml += '<img src="' + imgEl.src + '" alt="" loading="lazy">';
            cardHtml += '</a>';
            cardHtml += '<div class="wl-card__info">';
            cardHtml += '<a href="/products/' + handle + '" class="wl-card__title">' + (titleEl ? titleEl.textContent : 'Prodotto') + '</a>';
            cardHtml += '<div class="wl-card__price"><span>-</span></div>';
            cardHtml += '<div class="wl-card__stock wl-card__stock--available">Disponibile</div>';
            cardHtml += '<div class="wl-card__footer"><a href="/products/' + handle + '" class="wl-btn wl-btn--primary wl-btn--sm">Vedi Prodotto</a>';
            cardHtml += '<button class="wl-btn wl-btn--icon" onclick="removeFromWishlist(\'' + productId + '\')" aria-label="Rimuovi"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg></button>';
            cardHtml += '</div></div>';

            newCard.innerHTML = cardHtml;
            newCard.style.opacity = '0';
            newCard.style.transform = 'scale(.95)';
            grid.insertBefore(newCard, grid.firstChild);
            setTimeout(function() { newCard.style.transition = 'opacity .3s, transform .3s'; newCard.style.opacity = '1'; newCard.style.transform = 'scale(1)'; }, 50);
          }
          updateWishlistPageCount();
        }
      }
      showWlToast(wasIn ? 'Rimosso dalla wishlist' : 'Aggiunto alla wishlist!');
    }).catch(function () {
      // Rollback
      if (wasIn) { state.items.push(String(productId)); } else { state.items = state.items.filter(function (id) { return id !== String(productId); }); }
      updateUI();
    });
  });

  // ============================================================
  // WISHLIST PAGE FUNCTIONS (globali)
  // ============================================================

  // Sort
  window.sortWishlist = function(value) {
    var grid = document.getElementById('wlGrid');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll('[data-wl-card]'));
    cards.sort(function(a, b) {
      switch(value) {
        case 'name-asc': return a.dataset.productTitle.localeCompare(b.dataset.productTitle);
        case 'name-desc': return b.dataset.productTitle.localeCompare(a.dataset.productTitle);
        case 'price-asc': return parseFloat(a.dataset.productPrice) - parseFloat(b.dataset.productPrice);
        case 'price-desc': return parseFloat(b.dataset.productPrice) - parseFloat(a.dataset.productPrice);
        case 'deals': return parseFloat(b.dataset.productDeal || 0) - parseFloat(a.dataset.productDeal || 0);
        case 'recent': return parseInt(b.dataset.productOrder || 0) - parseInt(a.dataset.productOrder || 0);
        case 'oldest': return parseInt(a.dataset.productOrder || 0) - parseInt(b.dataset.productOrder || 0);
        case 'available-first':
          var aAvail = a.dataset.productAvailable === 'true' ? 1 : 0;
          var bAvail = b.dataset.productAvailable === 'true' ? 1 : 0;
          return bAvail - aAvail;
        case 'unavailable-first':
          var aUnavail = a.dataset.productAvailable === 'true' ? 0 : 1;
          var bUnavail = b.dataset.productAvailable === 'true' ? 0 : 1;
          return bUnavail - aUnavail;
        case 'low-stock':
          var aStock = parseInt(a.dataset.productStock || 999);
          var bStock = parseInt(b.dataset.productStock || 999);
          // Non disponibili in fondo, poi stock basso prima
          if (aStock === 0 && bStock !== 0) return 1;
          if (bStock === 0 && aStock !== 0) return -1;
          return aStock - bStock;
        default: return 0;
      }
    });
    cards.forEach(function(card) { grid.appendChild(card); });
  };

  // Filter search
  window.filterWishlist = function(query) {
    var q = query.toLowerCase();
    document.querySelectorAll('[data-wl-card]').forEach(function(card) {
      var title = card.dataset.productTitle.toLowerCase();
      card.style.display = (!q || title.includes(q)) ? '' : 'none';
    });
  };

  // Toggle unavailable
  window.toggleUnavailable = function(hide) {
    document.querySelectorAll('.wl-card--oos').forEach(function(card) {
      card.classList.toggle('wl-card--hidden', hide);
    });
  };

  // Add to wishlist (da destino, trending, ecc.)
  window.addToWishlist = function(productId) {
    if (isInWishlist(productId)) return;
    // Se ha più liste, mostra il modal di scelta lista
    var pageData = window.__wishlistPage;
    if (pageData && pageData.wishlistData && pageData.wishlistData.lists && pageData.wishlistData.lists.length > 1) {
      showAddToListModal(productId);
      return;
    }
    // Altrimenti aggiungi alla lista default
    state.items.push(String(productId));
    updateUI();
    apiCall('add', productId, 'La mia lista').then(function() {
      showWlToast('Aggiunto alla wishlist!');
    });
  };

  // Remove from wishlist
  window.removeFromWishlist = function(productId) {
    closeAllMenus();
    state.items = state.items.filter(function (id) { return id !== String(productId); });
    updateUI();
    apiCall('remove', productId).then(function() {
      var card = document.querySelector('[data-wl-card][data-product-id="' + productId + '"]');
      if (card) {
        card.style.transition = 'opacity .3s, transform .3s';
        card.style.opacity = '0';
        card.style.transform = 'scale(.95)';
        setTimeout(function() { card.remove(); updateWishlistPageCount(); }, 300);
      }
      showWlToast('Rimosso dalla wishlist');
    });
  };

  // Card menu
  window.openCardMenu = function(e, productId) {
    e.preventDefault();
    e.stopPropagation();
    closeAllMenus();
    var menu = document.getElementById('menu-' + productId);
    if (menu) menu.classList.toggle('open');
  };

  function closeAllMenus() {
    document.querySelectorAll('.wl-card__menu.open').forEach(function(m) { m.classList.remove('open'); });
  }
  document.addEventListener('click', function() { closeAllMenus(); });

  // Update count on page
  function updateWishlistPageCount() {
    var count = document.querySelectorAll('[data-wl-card]').length;
    var countEl = document.querySelector('.wl-header__count');
    if (countEl) countEl.textContent = count + ' gioch' + (count === 1 ? 'io salvato' : 'i salvati');
    // Mostra empty se zero
    if (count === 0) {
      var grid = document.getElementById('wlGrid');
      if (grid) grid.innerHTML = '<div class="wl-empty" style="grid-column:1/-1;"><div class="wl-empty__icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="72" height="72" fill="none" stroke="currentColor" stroke-width="1" opacity=".3"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg></div><h2 class="wl-empty__title">La tua wishlist è vuota</h2><p class="wl-empty__text">Esplora il nostro catalogo e salva i giochi che ti interessano</p><a href="/collections/tutto-il-catalogo" class="wl-btn wl-btn--primary">Esplora i Giochi</a></div>';
    }
  }

  // ============================================================
  // MULTI-LISTA (tabs)
  // ============================================================
  window.switchList = function(el, listName) {
    document.querySelectorAll('.wl-tab').forEach(function(t) { t.classList.remove('wl-tab--active'); });
    el.classList.add('wl-tab--active');

    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.wishlistData || !pageData.wishlistData.lists) {
      // Nessun dato multi-lista, mostra tutto
      document.querySelectorAll('[data-wl-card]').forEach(function(c) { c.style.display = ''; });
      return;
    }

    if (listName === 'La mia lista') {
      // "La mia lista" mostra tutti i prodotti CHE NON sono in altre liste custom
      var otherListIds = [];
      pageData.wishlistData.lists.forEach(function(l) {
        if (l.name !== 'La mia lista') {
          l.products.forEach(function(gid) {
            var pid = gid.replace('gid://shopify/Product/', '');
            if (otherListIds.indexOf(pid) === -1) otherListIds.push(pid);
          });
        }
      });
      // Inoltre mostra quelli esplicitamente in "La mia lista"
      var myList = pageData.wishlistData.lists.find(function(l) { return l.name === 'La mia lista'; });
      var myListIds = myList && myList.products ? myList.products.map(function(gid) { return gid.replace('gid://shopify/Product/', ''); }) : [];

      document.querySelectorAll('[data-wl-card]').forEach(function(card) {
        var pid = card.dataset.productId;
        var inMyList = myListIds.indexOf(pid) !== -1;
        var inOtherList = otherListIds.indexOf(pid) !== -1;
        var show = inMyList || !inOtherList;
        card.style.display = show ? '' : 'none';
        if (show) { card.style.opacity = ''; card.style.transform = ''; }
      });

      // Aggiorna conteggio: conta le card visibili
      var visibleCount = document.querySelectorAll('[data-wl-card]').length - document.querySelectorAll('[data-wl-card][style*="display: none"]').length;
      var defaultTab = document.querySelector('.wl-tab[data-list="default"]');
      if (defaultTab) {
        var countBadge = defaultTab.querySelector('.wl-tab__count');
        if (countBadge) countBadge.textContent = visibleCount;
      }
      return;
    }

    // Liste custom: filtra per prodotti assegnati
    var list = pageData.wishlistData.lists.find(function(l) { return l.name === listName; });
    var productIds = list ? list.products.map(function(gid) { return gid.replace('gid://shopify/Product/', ''); }) : [];

    document.querySelectorAll('[data-wl-card]').forEach(function(card) {
      var pid = card.dataset.productId;
      var show = productIds.indexOf(pid) !== -1;
      card.style.display = show ? '' : 'none';
      if (show) { card.style.opacity = ''; card.style.transform = ''; }
    });
  };

  // Init tabs from wishlist_data
  function initListTabs() {
    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.wishlistData || !pageData.wishlistData.lists) return;

    // Rimuovi duplicati dal nome
    var seen = {};
    pageData.wishlistData.lists = pageData.wishlistData.lists.filter(function(list) {
      if (seen[list.name]) return false;
      seen[list.name] = true;
      return true;
    });

    var tabsContainer = document.getElementById('wlTabs');
    if (!tabsContainer) return;

    // Rimuovi eventuali tab custom già create (evita duplicati), ma non "La mia lista" e "+ Nuova lista"
    tabsContainer.querySelectorAll('.wl-tab:not([data-list="default"]):not([data-list="all"]):not(.wl-tab--add)').forEach(function(t) { t.remove(); });

    var addBtn = tabsContainer.querySelector('.wl-tab--add');
    pageData.wishlistData.lists.forEach(function(list) {
      // Salta "La mia lista" perche' gia' nel Liquid
      if (list.name === 'La mia lista') return;
      var productCount = list.products ? list.products.length : 0;
      var tab = document.createElement('button');
      tab.className = 'wl-tab';
      tab.dataset.list = list.name;
      tab.onclick = function() { window.switchList(tab, list.name); };
      tab.innerHTML = list.name + ' <span class="wl-tab__count">' + productCount + '</span><span class="wl-tab__delete" onclick="event.stopPropagation();deleteList(\'' + list.name.replace(/'/g, '') + '\')" title="Elimina lista">&times;</span>';
      tab.setAttribute('data-list', list.name);
      tabsContainer.insertBefore(tab, addBtn);
    });
  }

  // Create new list
  window.createNewList = function() {
    document.getElementById('newListModal').classList.add('open');
    setTimeout(function() { document.getElementById('newListName').focus(); }, 100);
  };
  window.closeNewListModal = function() {
    document.getElementById('newListModal').classList.remove('open');
  };
  window.confirmNewList = function() {
    var name = document.getElementById('newListName').value.trim();
    if (!name) return;

    // Aggiungi tab
    var tabsContainer = document.getElementById('wlTabs');
    var addBtn = tabsContainer.querySelector('.wl-tab--add');
    var tab = document.createElement('button');
    tab.className = 'wl-tab';
    tab.dataset.list = name;
    tab.onclick = function() { window.switchList(tab, name); };
    tab.innerHTML = name + ' <span class="wl-tab__count">0</span><span class="wl-tab__delete" onclick="event.stopPropagation();deleteList(\'' + name.replace(/'/g, '') + '\')" title="Elimina lista">&times;</span>';
    tabsContainer.insertBefore(tab, addBtn);

    // Aggiorna wishlist_data locale
    var pageData = window.__wishlistPage;
    if (pageData) {
      if (!pageData.wishlistData) pageData.wishlistData = { lists: [] };
      if (!pageData.wishlistData.lists) pageData.wishlistData.lists = [];
      pageData.wishlistData.lists.push({ name: name, products: [] });
    }

    // Persisti sul server
    if (state.customerId) {
      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'create_list',
          customerId: String(state.customerId),
          listName: name
        })
      }).then(function(r) { return r.json(); }).then(function(d) {
        console.log('[Wishlist] Lista creata:', d);
      }).catch(function(err) { console.error('[Wishlist] Errore creazione lista:', err); });
    }

    closeNewListModal();
    document.getElementById('newListName').value = '';
    showWlToast('Lista "' + name + '" creata!');
  };

  // Move to list
  var moveProductId = null;
  window.moveToList = function(productId) {
    closeAllMenus();
    moveProductId = productId;
    var modal = document.getElementById('moveListModal');
    var body = document.getElementById('moveListBody');
    var pageData = window.__wishlistPage;

    // Trova la lista corrente del prodotto
    var currentListName = 'La mia lista';
    var productGid = 'gid://shopify/Product/' + productId;
    if (pageData && pageData.wishlistData && pageData.wishlistData.lists) {
      pageData.wishlistData.lists.forEach(function(list) {
        if (list.products && list.products.indexOf(productGid) !== -1) {
          currentListName = list.name;
        }
      });
    }
    moveFromList = currentListName;

    var html = '';
    if (pageData && pageData.wishlistData && pageData.wishlistData.lists) {
      pageData.wishlistData.lists.forEach(function(list) {
        // Non mostrare la lista in cui è già il prodotto
        if (list.name === currentListName) return;
        html += '<div class="wl-move-item" onclick="confirmMove(\'' + list.name.replace(/'/g, '') + '\')">' + list.name + ' (' + list.products.length + ')</div>';
      });
    }
    html += '<div class="wl-move-item" onclick="confirmMove(\'new\')">+ Crea nuova lista</div>';
    if (html === '<div class="wl-move-item" onclick="confirmMove(\'new\')">+ Crea nuova lista</div>') {
      html = '<div style="padding:.5rem 0;color:#888;font-size:.85rem;">Crea una nuova lista per spostare il gioco</div>' + html;
    }
    body.innerHTML = html;
    modal.classList.add('open');
  };
  var moveFromList = 'La mia lista';
  window.closeMoveListModal = function() { document.getElementById('moveListModal').classList.remove('open'); };
  window.confirmMove = function(listName) {
    if (listName === 'new') {
      closeMoveListModal();
      createNewList();
      return;
    }
    if (!moveProductId) { closeMoveListModal(); return; }

    closeMoveListModal();

    var pid = moveProductId;
    var productGid = 'gid://shopify/Product/' + pid;
    var pageData = window.__wishlistPage;

    // 1. Nascondi la card subito dalla vista corrente
    var card = document.querySelector('[data-wl-card][data-product-id="' + pid + '"]');
    if (card) {
      card.style.transition = 'opacity .3s, transform .3s';
      card.style.opacity = '0';
      card.style.transform = 'scale(.95)';
      setTimeout(function() { card.style.display = 'none'; }, 300);
    }

    // 2. Aggiorna wishlistData locale
    if (pageData && pageData.wishlistData && pageData.wishlistData.lists) {
      // Rimuovi da TUTTE le liste (non solo moveFromList)
      pageData.wishlistData.lists.forEach(function(list) {
        list.products = list.products.filter(function(p) { return p !== productGid; });
      });
      // Aggiungi alla lista destinazione
      var destList = pageData.wishlistData.lists.find(function(l) { return l.name === listName; });
      if (destList) {
        destList.products.push(productGid);
      }
    }

    // 3. Aggiorna conteggi tab
    document.querySelectorAll('.wl-tab').forEach(function(tab) {
      var tabDataList = tab.getAttribute('data-list');
      var tabName = (tabDataList === 'default') ? 'La mia lista' : tabDataList;
      if (!tabName) return;
      var countBadge = tab.querySelector('.wl-tab__count');
      if (!countBadge) return;

      if (tabName === listName) {
        // Lista destinazione: incrementa
        var destList = pageData.wishlistData.lists.find(function(l) { return l.name === tabName; });
        if (destList) countBadge.textContent = destList.products.length;
      } else if (tabName === 'La mia lista') {
        // "La mia lista": conta card visibili dopo l'animazione
        setTimeout(function() {
          var visible = document.querySelectorAll('[data-wl-card]');
          var count = 0;
          visible.forEach(function(c) { if (c.style.display !== 'none') count++; });
          countBadge.textContent = count;
        }, 350);
      }
    });

    showWlToast('Spostato in "' + listName + '"');

    // Chiamata API: azione move (singola operazione atomica)
    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        action: 'move',
        customerId: String(state.customerId),
        productId: String(moveProductId),
        fromList: moveFromList,
        toList: listName
      })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.error) throw new Error(data.error);
    })
    .catch(function() {
      showWlToast('Errore nello spostamento');
    });
  };

  // ============================================================
  // SHARE
  // ============================================================
  window.shareWishlist = function() {
    var modal = document.getElementById('shareModal');
    var products = state.items.join(',');
    var url = window.location.origin + '/pages/wishlist?shared=' + btoa(products);
    document.getElementById('shareLink').value = url;
    document.getElementById('shareWhatsApp').href = 'https://wa.me/?text=' + encodeURIComponent('Guarda la mia wishlist! ' + url);
    document.getElementById('shareEmail').href = 'mailto:?subject=' + encodeURIComponent('La mia Wishlist Frogames') + '&body=' + encodeURIComponent('Ecco i giochi che desidero: ' + url);
    modal.classList.add('open');
  };
  window.closeShareModal = function() { document.getElementById('shareModal').classList.remove('open'); };
  window.copyShareLink = function() {
    var input = document.getElementById('shareLink');
    input.select();
    document.execCommand('copy');
    showWlToast('Link copiato!');
  };

  // ============================================================
  // ADD TO LIST MODAL (scegli in quale lista aggiungere)
  // ============================================================
  var addToListProductId = null;

  window.showAddToListModal = function(productId) {
    addToListProductId = productId;
    var modal = document.getElementById('addToListModal');
    if (!modal) {
      // Crea modal al volo se non esiste
      modal = document.createElement('div');
      modal.className = 'wl-modal-overlay';
      modal.id = 'addToListModal';
      modal.onclick = function(ev) { if (ev.target === modal) closeAddToListModal(); };
      modal.innerHTML = '<div class="wl-modal"><div class="wl-modal__header"><h3>Aggiungi alla lista</h3><button onclick="closeAddToListModal()" class="wl-modal__close">&times;</button></div><div class="wl-modal__body" id="addToListBody"></div></div>';
      document.body.appendChild(modal);
    }

    var body = document.getElementById('addToListBody');
    var pageData = window.__wishlistPage;
    var html = '';
    if (pageData && pageData.wishlistData && pageData.wishlistData.lists) {
      pageData.wishlistData.lists.forEach(function(list) {
        html += '<div class="wl-move-item" onclick="confirmAddToList(\'' + list.name.replace(/'/g, '') + '\')">' + list.name + ' (' + (list.products ? list.products.length : 0) + ')</div>';
      });
    } else {
      html += '<div class="wl-move-item" onclick="confirmAddToList(\'La mia lista\')">La mia lista</div>';
    }
    body.innerHTML = html;
    modal.classList.add('open');
  };

  window.closeAddToListModal = function() {
    var modal = document.getElementById('addToListModal');
    if (modal) modal.classList.remove('open');
    addToListProductId = null;
  };

  window.confirmAddToList = function(listName) {
    var productId = addToListProductId;
    closeAddToListModal();
    if (!productId) return;

    // Optimistic UI
    state.items.push(String(productId));
    updateUI();

    apiCall('add', productId, listName).then(function() {
      // Aggiungi card alla griglia se siamo sulla pagina wishlist
      var grid = document.getElementById('wlGrid');
      if (grid && !document.querySelector('[data-wl-card][data-product-id="' + productId + '"]')) {
        var btn = document.querySelector('[data-wishlist-btn][data-product-id="' + productId + '"]');
        var trendingCard = btn ? btn.closest('.wl-card') : null;
        if (trendingCard) {
          var imgEl = trendingCard.querySelector('.wl-card__media img');
          var titleEl = trendingCard.querySelector('.wl-card__title');
          var titleLink = trendingCard.querySelector('a.wl-card__media');
          var handle = titleLink ? titleLink.getAttribute('href').replace('/products/', '') : '';

          var newCard = document.createElement('div');
          newCard.className = 'wl-card';
          newCard.setAttribute('data-wl-card', '');
          newCard.setAttribute('data-product-id', productId);
          newCard.setAttribute('data-product-title', titleEl ? titleEl.textContent : '');
          newCard.setAttribute('data-product-price', '0');
          newCard.setAttribute('data-product-available', 'true');
          newCard.setAttribute('data-product-deal', '0');
          newCard.innerHTML = '<a href="/products/' + handle + '" class="wl-card__media">' + (imgEl ? '<img src="' + imgEl.src + '" alt="" loading="lazy">' : '') + '</a><div class="wl-card__info"><a href="/products/' + handle + '" class="wl-card__title">' + (titleEl ? titleEl.textContent : '') + '</a><div class="wl-card__footer"><a href="/products/' + handle + '" class="wl-btn wl-btn--primary wl-btn--sm">Vedi Prodotto</a><button class="wl-btn wl-btn--icon" onclick="removeFromWishlist(\'' + productId + '\')"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg></button></div></div>';
          newCard.style.opacity = '0';
          grid.insertBefore(newCard, grid.firstChild);
          setTimeout(function() { newCard.style.transition = 'opacity .3s, transform .3s'; newCard.style.opacity = '1'; }, 50);
        }
        updateWishlistPageCount();
      }

      // Aggiorna wishlist_data locale
      var pageData = window.__wishlistPage;
      if (pageData && pageData.wishlistData && pageData.wishlistData.lists) {
        var list = pageData.wishlistData.lists.find(function(l) { return l.name === listName; });
        if (list) {
          var gid = 'gid://shopify/Product/' + productId;
          if (!list.products.includes(gid)) list.products.push(gid);
          // Aggiorna tab count
          var tab = document.querySelector('.wl-tab[data-list="' + listName + '"] .wl-tab__count');
          if (tab) tab.textContent = list.products.length;
        }
      }

      showWlToast('Aggiunto a "' + listName + '"!');
    }).catch(function() {
      state.items = state.items.filter(function(id) { return id !== String(productId); });
      updateUI();
    });
  };

  // ============================================================
  // ADD TO CART
  // ============================================================
  window.addToCart = function(variantId, btnEl) {
    if (!variantId) { showWlToast('Errore: variante non trovata'); return; }
    var originalText = btnEl.innerHTML;
    btnEl.disabled = true;
    btnEl.innerHTML = 'Aggiunta...';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Errore ' + res.status);
      return res.json();
    })
    .then(function() {
      btnEl.innerHTML = 'Aggiunto!';
      btnEl.style.background = '#8CD300';
      btnEl.style.color = '#0f1117';

      // Apri il cart drawer
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));

      setTimeout(function() {
        btnEl.innerHTML = originalText;
        btnEl.style.background = '';
        btnEl.style.color = '';
        btnEl.disabled = false;
      }, 2000);
    })
    .catch(function(err) {
      console.error('[Wishlist] Add to cart error:', err);
      btnEl.innerHTML = 'Errore';
      showWlToast('Errore aggiunta al carrello');
      setTimeout(function() { btnEl.innerHTML = originalText; btnEl.disabled = false; }, 2000);
    });
  };

  // ============================================================
  // MULTI-SELECT
  // ============================================================
  var selectedItems = [];

  window.toggleSelectMode = function() {
    var btn = document.getElementById('selectModeBtn');
    var checkboxes = document.querySelectorAll('.wl-card__checkbox');
    var isActive = btn.dataset.active === 'true';

    if (!isActive) {
      btn.dataset.active = 'true';
      btn.style.background = '#8CD300';
      btn.style.color = '#0f1117';
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:4px;"><path d="M18 6L6 18M6 6l12 12"/></svg> Esci selezione';
      // Mostra tutti i checkbox
      checkboxes.forEach(function(cb) { cb.style.opacity = '1'; cb.style.display = 'flex'; });
    } else {
      btn.dataset.active = 'false';
      btn.style.background = '';
      btn.style.color = '';
      btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:4px;"><rect x="3" y="3" width="18" height="18" rx="2"/><path d="M9 12l2 2 4-4"/></svg> Seleziona';
      // Nascondi tutti i checkbox
      checkboxes.forEach(function(cb) { cb.style.opacity = ''; cb.style.display = ''; });
      clearSelection();
    }
  };

  window.toggleSelectCard = function(e, productId, variantId) {
    e.preventDefault();
    e.stopPropagation();
    var card = document.querySelector('.wl-card[data-product-id="' + productId + '"]');
    if (!card) return;
    var checkbox = card.querySelector('.wl-card__checkbox');
    if (!checkbox) return;
    var idx = selectedItems.findIndex(function(i) { return i.productId === productId; });

    if (idx > -1) {
      selectedItems.splice(idx, 1);
      checkbox.classList.remove('checked');
      card.classList.remove('wl-card--selected');
    } else {
      selectedItems.push({ productId: productId, variantId: variantId || '' });
      checkbox.classList.add('checked');
      card.classList.add('wl-card--selected');
    }
    updateSelectionBar();
  };

  function updateSelectionBar() {
    var bar = document.getElementById('selectionBar');
    var countEl = document.getElementById('selectedCount');
    if (!bar) return;
    if (selectedItems.length > 0) {
      bar.classList.add('show');
      countEl.textContent = selectedItems.length;
    } else {
      bar.classList.remove('show');
    }
  }

  window.clearSelection = function() {
    selectedItems = [];
    document.querySelectorAll('.wl-card--selected').forEach(function(c) { c.classList.remove('wl-card--selected'); });
    document.querySelectorAll('.wl-card__checkbox.checked').forEach(function(c) { c.classList.remove('checked'); });
    updateSelectionBar();
  };

  window.removeSelected = function() {
    if (selectedItems.length === 0) return;
    var count = selectedItems.length;
    // Mostra modal di conferma
    var modal = document.getElementById('removeSelectedModal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'wl-modal-overlay';
      modal.id = 'removeSelectedModal';
      modal.onclick = function(ev) { if (ev.target === modal) modal.classList.remove('open'); };
      modal.innerHTML = '<div class="wl-modal"><div class="wl-modal__header"><h3>Rimuovi dalla wishlist</h3><button onclick="document.getElementById(\'removeSelectedModal\').classList.remove(\'open\')" class="wl-modal__close">&times;</button></div><div class="wl-modal__body"><p id="removeSelectedText"></p><div style="margin-top:1rem;display:flex;gap:.5rem;"><button onclick="confirmRemoveSelected()" class="wl-btn wl-btn--deal" style="flex:1;">Rimuovi</button><button onclick="document.getElementById(\'removeSelectedModal\').classList.remove(\'open\')" class="wl-btn wl-btn--ghost" style="flex:1;">Annulla</button></div></div></div>';
      document.body.appendChild(modal);
    }
    document.getElementById('removeSelectedText').textContent = 'Sei sicuro di voler rimuovere ' + count + ' gioc' + (count === 1 ? 'o' : 'hi') + ' dalla wishlist?';
    modal.classList.add('open');
  };

  window.confirmRemoveSelected = function() {
    document.getElementById('removeSelectedModal').classList.remove('open');
    var count = selectedItems.length;
    if (count === 0) return;
    var productIds = selectedItems.map(function(item) { return String(item.productId); });

    // Rimuovi subito dallo stato locale
    state.items = state.items.filter(function(id) { return productIds.indexOf(id) === -1; });
    updateUI();

    // Anima le card in uscita
    productIds.forEach(function(pid) {
      var card = document.querySelector('[data-wl-card][data-product-id="' + pid + '"]');
      if (card) {
        card.style.transition = 'opacity .3s, transform .3s';
        card.style.opacity = '0';
        card.style.transform = 'scale(.95)';
      }
    });

    // Reset selezione subito
    selectedItems = [];
    updateSelectionBar();
    showWlToast(count + ' giochi rimossi');

    // Aggiorna subito tutti i conteggi
    var remaining = state.items.length;
    document.querySelectorAll('.wl-header__count').forEach(function(el) {
      el.textContent = remaining + ' gioch' + (remaining === 1 ? 'io salvato' : 'i salvati');
    });
    document.querySelectorAll('[data-wishlist-count]').forEach(function(el) {
      el.textContent = remaining;
      remaining > 0 ? el.removeAttribute('hidden') : el.setAttribute('hidden', '');
    });

    // Rimuovi card dal DOM dopo animazione (300ms)
    setTimeout(function() {
      productIds.forEach(function(pid) {
        var card = document.querySelector('[data-wl-card][data-product-id="' + pid + '"]');
        if (card) card.remove();
      });
      updateWishlistPageCount();
    }, 350);

    // Chiamata API: prova bulk-remove, fallback a rimozione sequenziale
    fetch(WORKER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ action: 'bulk-remove', customerId: String(state.customerId), productIds: productIds })
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.error) throw new Error(data.error);
      if (data.wishlist) { state.items = data.wishlist.map(String); updateUI(); }
    })
    .catch(function() {
      // Fallback: rimozione sequenziale (una alla volta, in serie)
      var chain = Promise.resolve();
      productIds.forEach(function(pid) {
        chain = chain.then(function() { return apiCall('remove', pid); });
      });
      chain.catch(function() { showWlToast('Errore nella rimozione'); });
    });
  };

  window.addSelectedToCart = function() {
    if (selectedItems.length === 0) return;
    var items = selectedItems.filter(function(i) { return i.variantId; }).map(function(i) {
      return { id: parseInt(i.variantId), quantity: 1 };
    });
    if (items.length === 0) { showWlToast('Nessun prodotto disponibile'); return; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(res) { return res.json(); })
    .then(function() {
      showWlToast(items.length + ' giochi aggiunti al carrello!');
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      clearSelection();
    })
    .catch(function() { showWlToast('Errore aggiunta al carrello'); });
  };

  // ============================================================
  // DELETE LIST
  // ============================================================
  var deleteListTarget = null;

  window.deleteList = function(listName) {
    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.wishlistData || !pageData.wishlistData.lists) return;

    // Non si puo eliminare se e' l'unica lista rimasta
    if (pageData.wishlistData.lists.length <= 1) {
      showWlToast('Non puoi eliminare l\'unica lista!');
      return;
    }

    deleteListTarget = listName;
    document.getElementById('deleteListName').textContent = listName;
    document.getElementById('deleteListModal').classList.add('open');
  };

  window.closeDeleteListModal = function() {
    document.getElementById('deleteListModal').classList.remove('open');
    deleteListTarget = null;
  };

  window.confirmDeleteList = function() {
    if (!deleteListTarget) return;
    var listName = deleteListTarget;
    closeDeleteListModal();

    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.wishlistData) return;

    // Rimuovi la tab
    var tab = document.querySelector('.wl-tab[data-list="' + listName + '"]');
    if (tab) tab.remove();

    // Torna a "Tutti"
    var allTab = document.querySelector('.wl-tab[data-list="all"]');
    if (allTab) window.switchList(allTab, 'all');

    // Aggiorna wishlist_data locale
    pageData.wishlistData.lists = pageData.wishlistData.lists.filter(function(l) { return l.name !== listName; });

    showWlToast('Lista "' + listName + '" eliminata');

    // Persisti sul server
    if (state.customerId) {
      fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          action: 'delete_list',
          customerId: String(state.customerId),
          listName: listName
        })
      }).then(function(r) { return r.json(); }).then(function(d) {
        console.log('[Wishlist] Lista eliminata:', d);
      }).catch(function(err) { console.error('[Wishlist] Errore eliminazione lista:', err); });
    }
  };

  // ============================================================
  // SMART CART (combinazioni spedizione gratuita)
  // ============================================================
  function loadSmartCart() {
    var container = document.getElementById('wlSmartCartBody');
    if (!container) return;

    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.products) { container.innerHTML = ''; return; }

    var threshold = 5000; // 50 EUR in centesimi
    var isPlayBold = pageData.isPlayBold || false;

    var available = pageData.products.filter(function(p) { return p.available && p.price >= 500; }).map(function(p) {
      var prod = Object.assign({}, p);
      if (isPlayBold) {
        var isPreorder = prod.tags && prod.tags.indexOf('preordine') !== -1;
        var discount = isPreorder ? 0.15 : 0.12;
        prod.discountedPrice = Math.round(prod.price * (1 - discount));
      } else {
        prod.discountedPrice = prod.price;
      }
      return prod;
    });

    if (available.length === 0) {
      container.innerHTML = '<div style="padding:1rem;color:#888;font-size:.85rem;">Nessun prodotto disponibile nella wishlist</div>';
      return;
    }

    // Ordina per prezzo scontato
    available.sort(function(a, b) { return a.discountedPrice - b.discountedPrice; });

    // Trova fino a 3 combinazioni diverse che superano la soglia
    var combos = [];

    // Combo 1: i piu economici
    var combo1 = findCombo(available, threshold, 'cheap');
    if (combo1) combos.push({ label: 'Risparmio massimo', emoji: '&#x1f4b0;', products: combo1 });

    // Combo 2: 2 giochi
    var combo2 = findComboExact(available, threshold, 2);
    if (combo2 && !isSameCombo(combo2, combo1)) combos.push({ label: 'Solo 2 giochi', emoji: '&#x270c;', products: combo2 });

    // Combo 3: singolo sopra soglia
    var combo3 = findSingleAbove(available, threshold);
    if (combo3) combos.push({ label: 'Un solo gioco', emoji: '&#x1f3af;', products: combo3 });

    // Combo 4-5: random (evita duplicati)
    var randomLabels = [['Mix sorpresa', '&#x1f3b2;'], ['Altra idea', '&#x1f500;']];
    var attempts = 0;
    var added = 0;
    while (added < 2 && attempts < 10) {
      attempts++;
      var shuffled = available.slice().sort(function() { return Math.random() - 0.5; });
      var rc = []; var rt = 0;
      for (var ri = 0; ri < shuffled.length && rt < threshold; ri++) { rc.push(shuffled[ri]); rt += shuffled[ri].discountedPrice; }
      if (rt < threshold) continue;
      // Controlla che non sia duplicato di combo esistenti
      var isDup = false;
      for (var ci = 0; ci < combos.length; ci++) {
        if (isSameCombo(rc, combos[ci].products)) { isDup = true; break; }
      }
      if (!isDup) {
        combos.push({ label: randomLabels[added][0], emoji: randomLabels[added][1], products: rc });
        added++;
      }
    }

    if (combos.length === 0) {
      container.innerHTML = '<div style="padding:2rem;text-align:center;color:#888;">Nessuna combinazione disponibile</div>';
      return;
    }

    var html = '';
    combos.forEach(function(combo) {
      var total = combo.products.reduce(function(sum, p) { return sum + p.price; }, 0);
      var discountedTotal = combo.products.reduce(function(sum, p) { return sum + p.discountedPrice; }, 0);
      var variantIds = combo.products.map(function(p) { return p.variantId; }).filter(Boolean);

      html += '<div class="wl-combo-card">';
      html += '<div class="wl-combo-card__header"><span class="wl-combo-card__emoji">' + (combo.emoji || '') + '</span><span class="wl-combo-card__label">' + combo.label + '</span><span class="wl-combo-card__count">' + combo.products.length + ' giochi</span></div>';
      html += '<div class="wl-combo-card__products">';
      combo.products.forEach(function(p, i) {
        html += '<a href="/products/' + (p.handle || '') + '" class="wl-combo-card__product">';
        if (p.image) html += '<img src="' + p.image + '">';
        html += '<div class="wl-combo-card__product-info"><div class="wl-combo-card__product-name">' + p.title + '</div>';
        if (isPlayBold && p.discountedPrice < p.price) {
          html += '<div class="wl-combo-card__product-price"><s style="color:#aaa;font-weight:400;">' + (p.price / 100).toFixed(2) + '</s> <span style="color:#111;font-weight:700;">' + (p.discountedPrice / 100).toFixed(2) + ' EUR</span></div>';
        } else {
          html += '<div class="wl-combo-card__product-price">' + (p.price / 100).toFixed(2) + ' EUR</div>';
        }
        html += '</div></a>';
      });
      html += '</div>';
      html += '<div class="wl-combo-card__footer">';
      if (isPlayBold && discountedTotal < total) {
        html += '<div><span class="wl-combo-card__total" style="text-decoration:line-through;color:#aaa;font-weight:400;font-size:.8rem;">' + (total / 100).toFixed(2) + '</span> <span class="wl-combo-card__total">' + (discountedTotal / 100).toFixed(2) + ' EUR</span><span class="wl-combo-card__free">Spedizione gratuita (PlayBold)</span></div>';
      } else {
        html += '<div><span class="wl-combo-card__total">' + (discountedTotal / 100).toFixed(2) + ' EUR</span><span class="wl-combo-card__free">Spedizione gratuita</span></div>';
      }
      if (variantIds.length > 0) {
        html += '<button class="wl-btn wl-btn--primary wl-btn--sm wl-combo-buy" data-variants="' + variantIds.join(',') + '">Aggiungi al carrello</button>';
      }
      html += '</div></div>';
    });

    container.innerHTML = html;

    // Attach listeners per combo buy
    container.querySelectorAll('.wl-combo-buy').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var vids = btn.dataset.variants.split(',');
        addComboToCart(vids);
      });
    });
  }

  function findCombo(products, threshold, mode) {
    var combo = [];
    var total = 0;
    var sorted = mode === 'cheap' ? products.slice() : products.slice().reverse();
    for (var i = 0; i < sorted.length && total < threshold; i++) {
      combo.push(sorted[i]);
      total += sorted[i].discountedPrice;
    }
    return total >= threshold ? combo : null;
  }

  function findComboExact(products, threshold, count) {
    // Trova la migliore combinazione di esattamente N prodotti che supera la soglia
    if (products.length < count) return null;
    var best = null;
    var bestTotal = Infinity;

    for (var i = 0; i < products.length; i++) {
      if (count === 2) {
        for (var j = i + 1; j < products.length; j++) {
          var total = products[i].discountedPrice + products[j].discountedPrice;
          if (total >= threshold && total < bestTotal) {
            best = [products[i], products[j]];
            bestTotal = total;
          }
        }
      }
    }
    return best;
  }

  function findSingleAbove(products, threshold) {
    var best = null;
    var bestDiff = Infinity;
    products.forEach(function(p) {
      if (p.discountedPrice >= threshold) {
        var diff = p.discountedPrice - threshold;
        if (diff < bestDiff) { best = p; bestDiff = diff; }
      }
    });
    return best ? [best] : null;
  }

  function isSameCombo(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    var aIds = a.map(function(p) { return p.id; }).sort().join(',');
    var bIds = b.map(function(p) { return p.id; }).sort().join(',');
    return aIds === bIds;
  }

  window.addComboToCart = function(variantIds) {
    var items = variantIds.map(function(vid) { return { id: parseInt(vid), quantity: 1 }; });
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(r) { return r.json(); })
    .then(function() {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
      showWlToast(variantIds.length + ' giochi aggiunti al carrello!');
    })
    .catch(function() { showWlToast('Errore aggiunta al carrello'); });
  };

  // ============================================================
  // SCEGLI IL DESTINO (con filtri categoria)
  // ============================================================
  var destinyHistory = []; // Evita ripetizioni nella sessione

  // Tag da ignorare nel destino
  var ignoreTags = ['in-wishlist','preordine','consegna-aggiornata','bestsellers-resort','br-trending','br-new','wf-top-20-most-viewed','nuovo','Italiano','Inglese','(Self-Published)'];
  // Tag che sono meccaniche
  var mechanicTags = ['Cooperative Game','Trick-taking','Push Your Luck','Deck Building','Deck Building','Dice','Dice Rolling','Worker Placement','Area Control','Set Collection','Hand Management','Drafting','Auction','Bluffing','Deduction','Pattern Building','Tile Placement','Route Building','Pick-up and Deliver','Engine Building','Variable Player Powers','Action Points','Card Drafting','Re-rolling and Locking','Die Icon Resolution','Player Elimination','Semi-Cooperative Game','Take That','Open Drafting','Hidden Roles','Word Game','gestione mano','lancio di dadi','piazzamento lavoratori','piazzamento tessere','economico','Modular Board','Area Majority / Influence','Narrative Choice / Paragraph','Card Play Conflict Resolution','Role Playing','Area Movement','Delayed Purchase','Variable Set-up','Card Game','End Game Bonuses','Induction','Events','Action / Event','Abstract Strategy','Network and Route Building','Chit-Pull System','Simulation','Simultaneous Action Selection','Trading','Negotiation','Memory','Race','Campaign / Battle Card Driven','Hex-and-Counter','Point to Point Movement','Grid Movement','Line Drawing','Connections','Solo Game','Puzzle','Real-Time'];
  // Tag che sono tipo gioco
  var typeTags = ['Gioco per famiglie','Gioco in solitario','Solo / Solitaire Game','Family','party games','Strategia','gioco di carte','Gioco tematico'];
  // Parole che NON sono nomi di persone
  var notPeople = ['Game','Board','Theme','Video','Card','Dice','Player','Solo','Set','Area','Role','Action','City','Science','Fantasy','Horror','Adventure','Expansion','Miniatures','Post','Open','Hidden','Push','Take','Pick','Route','Engine','Pattern','Tile','Worker','Modular','Variable','End','Delayed','Narrative','Base','Resolution','Conflict','Abstract','Strategy','Network','Building','System','Simulation','Trading','Negotiation','Memory','Race','Campaign','Battle','Movement','Drawing','Connections','Puzzle','Real','Time','Selection','Management','Points','Placement'];

  // Genera combo random
  window.generateRandomCombo = function() {
    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.products) return;
    var threshold = 5000;
    var isPlayBold = pageData.isPlayBold || false;
    var available = pageData.products.filter(function(p) { return p.available && p.price >= 500; }).map(function(p) {
      var prod = Object.assign({}, p);
      if (isPlayBold) {
        var isPreorder = prod.tags && prod.tags.indexOf('preordine') !== -1;
        prod.discountedPrice = Math.round(prod.price * (1 - (isPreorder ? 0.15 : 0.12)));
      } else {
        prod.discountedPrice = prod.price;
      }
      return prod;
    });
    if (available.length === 0) { showWlToast('Nessun prodotto disponibile'); return; }

    // Shuffle
    var shuffled = available.slice().sort(function() { return Math.random() - 0.5; });
    var combo = [];
    var total = 0;
    for (var i = 0; i < shuffled.length && total < threshold; i++) {
      combo.push(shuffled[i]);
      total += shuffled[i].discountedPrice;
    }

    if (total < threshold) { showWlToast('Non ci sono abbastanza giochi per raggiungere la soglia'); return; }

    var totalOriginal = combo.reduce(function(s, p) { return s + p.price; }, 0);
    var variantIds = combo.map(function(p) { return p.variantId; }).filter(Boolean);
    var container = document.getElementById('wlSmartCartBody');
    var html = '<div class="wl-combo-card" style="border-color:#8CD300;">';
    html += '<div class="wl-combo-card__header"><span class="wl-combo-card__emoji">&#x1f3b2;</span><span class="wl-combo-card__label" style="color:#8CD300;">Combinazione casuale</span><span class="wl-combo-card__count">' + combo.length + ' giochi</span></div>';
    html += '<div class="wl-combo-card__products">';
    combo.forEach(function(p, i) {
      html += '<a href="/products/' + (p.handle || '') + '" class="wl-combo-card__product">';
      if (p.image) html += '<img src="' + p.image + '">';
      html += '<div class="wl-combo-card__product-info"><div class="wl-combo-card__product-name">' + p.title + '</div>';
      if (isPlayBold && p.discountedPrice < p.price) {
        html += '<div class="wl-combo-card__product-price"><s style="color:#aaa;font-weight:400;">' + (p.price / 100).toFixed(2) + '</s> <span style="color:#111;font-weight:700;">' + (p.discountedPrice / 100).toFixed(2) + ' EUR</span></div>';
      } else {
        html += '<div class="wl-combo-card__product-price">' + (p.price / 100).toFixed(2) + ' EUR</div>';
      }
      html += '</div></a>';
    });
    html += '</div>';
    html += '<div class="wl-combo-card__footer">';
    if (isPlayBold && total < totalOriginal) {
      html += '<div><span class="wl-combo-card__total" style="text-decoration:line-through;color:#aaa;font-weight:400;font-size:.8rem;">' + (totalOriginal / 100).toFixed(2) + '</span> <span class="wl-combo-card__total">' + (total / 100).toFixed(2) + ' EUR</span><span class="wl-combo-card__free">Spedizione gratuita (PlayBold)</span></div>';
    } else {
      html += '<div><span class="wl-combo-card__total">' + (total / 100).toFixed(2) + ' EUR</span><span class="wl-combo-card__free">Spedizione gratuita</span></div>';
    }
    if (variantIds.length > 0) {
      html += '<button class="wl-btn wl-btn--primary wl-btn--sm wl-combo-buy" data-variants="' + variantIds.join(',') + '">Aggiungi al carrello</button>';
    }
    html += '</div></div>';

    // Inserisci in cima
    container.insertAdjacentHTML('afterbegin', html);
    // Attach listener
    var newBtn = container.querySelector('.wl-combo-card:first-child .wl-combo-buy');
    if (newBtn) newBtn.addEventListener('click', function(e) { e.preventDefault(); e.stopPropagation(); addComboToCart(newBtn.dataset.variants.split(',')); });
    showWlToast('Nuova combinazione generata!');
  };

  // Destino: carica opzioni nella vista
  window.loadDestinyOptions = function() {
    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.products || pageData.products.length === 0) return;

    // I prodotti sono ordinati dal più recente (primo aggiunto di recente) al più vecchio
    var allProducts = pageData.products;
    if (allProducts.length === 0) { showWlToast('Nessun prodotto nella wishlist'); return; }

    // Raccogli dati dai tag — i prodotti più recenti pesano di più
    var mechanics = {};
    var types = {};
    var publishers = {};

    allProducts.forEach(function(p, idx) {
      // Peso: i primi 20 prodotti (più recenti) contano 3, i successivi 20 contano 2, il resto 1
      var weight = idx < 20 ? 3 : (idx < 40 ? 2 : 1);
      publishers[p.vendor || '?'] = (publishers[p.vendor || '?'] || 0) + weight;
      if (!p.tags) return;
      p.tags.forEach(function(tag) {
        if (ignoreTags.indexOf(tag) > -1 || tag.indexOf('wishlist') > -1) return;
        if (mechanicTags.indexOf(tag) > -1) {
          mechanics[tag] = (mechanics[tag] || 0) + weight;
        } else if (typeTags.indexOf(tag) > -1) {
          types[tag] = (types[tag] || 0) + weight;
        }
      });
    });

    var body = document.getElementById('wlDestinyBody');
    var result = document.getElementById('wlDestinyResult');
    if (!body) return;
    result.style.display = 'none';
    body.style.display = 'block';
    var html = '<div class="wl-destiny-grid">';

    // Casuale
    html += '<div class="wl-destiny-option wl-destiny-option--main" onclick="spinDestiny(\'all\')">';
    html += '<span>&#x1f3b2;</span><div><strong>Casuale</strong><span class="wl-destiny-sub">Scopri un gioco nuovo dal catalogo</span></div></div>';

    // Tipo gioco
    var topTypes = Object.entries(types).sort(function(a,b){return b[1]-a[1];}).slice(0,10);
    if (topTypes.length > 0) {
      html += '<div class="wl-destiny-section">Tipo di gioco</div>';
      topTypes.forEach(function(t) {
        html += '<div class="wl-destiny-option" onclick="spinDestiny(\'tag\',\'' + t[0].replace(/'/g,'') + '\')">';
        html += '<span>&#x1f3ae;</span><div><strong>' + t[0] + '</strong></div></div>';
      });
    }

    // Meccaniche
    var topMech = Object.entries(mechanics).sort(function(a,b){return b[1]-a[1];}).slice(0,15);
    if (topMech.length > 0) {
      html += '<div class="wl-destiny-section">Meccanica</div>';
      topMech.forEach(function(m) {
        html += '<div class="wl-destiny-option" onclick="spinDestiny(\'tag\',\'' + m[0].replace(/'/g,'') + '\')">';
        html += '<span>&#x2699;</span><div><strong>' + m[0] + '</strong></div></div>';
      });
    }

    // Editori
    var topPubs = Object.entries(publishers).filter(function(p){return p[1]>=2;}).sort(function(a,b){return b[1]-a[1];}).slice(0,15);
    if (topPubs.length > 0) {
      html += '<div class="wl-destiny-section">Editore</div>';
      topPubs.forEach(function(p) {
        html += '<div class="wl-destiny-option" onclick="spinDestiny(\'vendor\',\'' + p[0].replace(/'/g,'') + '\')">';
        html += '<span>&#x1f3ed;</span><div><strong>' + p[0] + '</strong></div></div>';
      });
    }

    html += '</div>';
    body.innerHTML = html;
  };

  // Anche chooseDestiny per il bottone nella toolbar
  window.chooseDestiny = function() {
    var destBtn = document.querySelector('[data-view="destino"]');
    if (destBtn) switchView(destBtn, 'destino');
  };

  window.spinDestiny = function(filterType, filterValue) {
    var pageData = window.__wishlistPage;
    var wishlistIds = state.items.map(String);

    var body = document.getElementById('wlDestinyBody');
    var result = document.getElementById('wlDestinyResult');
    body.style.display = 'none';
    result.style.display = 'block';
    result.innerHTML = '<div style="text-align:center;padding:3rem 0;"><div style="font-size:1.2rem;font-weight:700;min-height:2em;" id="destinySpinner">Cerco nel catalogo...</div></div>';

    // Scroll alla vista destino per evitare che il browser salti al footer
    var destView = document.getElementById('view-destino');
    if (destView) {
      var offset = 100;
      var top = destView.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }

    // Cerca nel catalogo completo via Shopify search API
    var query = '';
    if (filterType === 'tag') {
      query = filterValue;
    } else if (filterType === 'vendor') {
      query = filterValue;
    } else {
      // Casuale: usa un tag random dalla wishlist dell'utente
      var allTags = [];
      if (pageData && pageData.products) {
        pageData.products.forEach(function(p) {
          if (p.tags) p.tags.forEach(function(t) {
            if (mechanicTags.indexOf(t) > -1 || typeTags.indexOf(t) > -1) allTags.push(t);
          });
        });
      }
      if (allTags.length > 0) {
        query = allTags[Math.floor(Math.random() * allTags.length)];
      } else {
        query = 'gioco da tavolo';
      }
    }

    // Strategia: cerca nel catalogo. Per tag, prova prima la ricerca testuale.
    // Se non trova risultati, usa recommendations da un prodotto della wishlist con quel tag.
    function searchCatalog(q) {
      return fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=25&resources[options][unavailable_products]=hide')
        .then(function(res) { return res.json(); })
        .then(function(data) { return (data.resources && data.resources.results && data.resources.results.products) || []; });
    }

    function getRecommendations(productId) {
      return fetch('/recommendations/products.json?product_id=' + productId + '&limit=10')
        .then(function(r) { return r.json(); })
        .then(function(d) { return d.products || []; });
    }

    // Trova un prodotto dalla wishlist con il tag/vendor specificato (per recommendations fallback)
    function findWishlistProductForFilter(fType, fValue) {
      if (!pageData || !pageData.products) return null;
      var matching = pageData.products.filter(function(p) {
        if (fType === 'tag') return p.tags && p.tags.indexOf(fValue) > -1;
        if (fType === 'vendor') return p.vendor === fValue;
        return true;
      });
      return matching.length > 0 ? matching[Math.floor(Math.random() * matching.length)] : null;
    }

    searchCatalog(query)
    .then(function(products) {
      // Se la ricerca testuale non trova nulla, prova con recommendations
      if (products.length === 0) {
        var wlProd = findWishlistProductForFilter(filterType, filterValue);
        if (wlProd) return getRecommendations(wlProd.id);
        // Ultimo tentativo: recommendations da qualsiasi prodotto wishlist
        if (pageData && pageData.products && pageData.products.length > 0) {
          var rnd = pageData.products[Math.floor(Math.random() * pageData.products.length)];
          return getRecommendations(rnd.id);
        }
      }
      return products;
    })
    .then(function(products) {
      if (!products || products.length === 0) {
        result.innerHTML = '<div style="text-align:center;padding:2rem;color:#888;">Nessun gioco trovato per questa categoria</div><div style="text-align:center;margin-top:1rem;"><button class="wl-btn wl-btn--ghost" onclick="loadDestinyOptions()">Cambia filtro</button></div>';
        return;
      }

      // Escludi prodotti gia in wishlist
      var filtered = products.filter(function(p) {
        var pPrice = parseFloat(p.price) || 0;
        if (pPrice < 100) pPrice = pPrice * 100;
        return wishlistIds.indexOf(String(p.id)) === -1 && p.available !== false && pPrice >= 500;
      });

      // Se tutti sono in wishlist, mostra comunque
      if (filtered.length === 0) filtered = products.filter(function(p) { return p.available !== false; });
      if (filtered.length === 0) filtered = products;

      // Evita ripetizioni nella sessione
      var notShown = filtered.filter(function(p) { return destinyHistory.indexOf(String(p.id)) === -1; });
      if (notShown.length === 0) { destinyHistory = []; notShown = filtered; }

      var chosen = notShown[Math.floor(Math.random() * notShown.length)];
      destinyHistory.push(String(chosen.id));

      // Fetch product JSON in parallelo con lo spinner (così è pronto quando lo spinner finisce)
      var productDataPromise = fetch('/products/' + chosen.handle + '.js').then(function(r) { return r.json(); });

      // Pre-carica l'immagine
      var imgUrl = chosen.image
        || (typeof chosen.featured_image === 'string' ? chosen.featured_image : '')
        || (chosen.featured_image && chosen.featured_image.url ? chosen.featured_image.url : '')
        || (chosen.images && chosen.images[0] ? chosen.images[0] : '')
        || '';
      if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
      if (imgUrl) { var preload = new Image(); preload.src = imgUrl; }

      // Animazione spinner con titoli random
      var allNames = filtered.map(function(p) { return p.title; });
      var spinCount = 0;
      var max = 10;
      var interval = setInterval(function() {
        spinCount++;
        var spinner = document.getElementById('destinySpinner');
        if (spinner) spinner.textContent = allNames[Math.floor(Math.random() * allNames.length)];

        if (spinCount >= max) {
          clearInterval(interval);
          productDataPromise
          .then(function(prod) {
            var price = prod.price || 0;
            // Usa immagine dal product JSON se disponibile (migliore qualità)
            if (prod.featured_image) {
              var prodImg = typeof prod.featured_image === 'string' ? prod.featured_image : (prod.featured_image.src || '');
              if (prodImg) imgUrl = prodImg;
            }
            if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
            var variantId = (prod.variants && prod.variants[0]) ? prod.variants[0].id : '';
            var inWishlist = wishlistIds.indexOf(String(chosen.id)) > -1;
            var productUrl = '/products/' + chosen.handle;

            var html = '<div style="text-align:center;padding:2rem 0;">';
            if (imgUrl) html += '<img src="' + imgUrl + '" style="width:220px;height:220px;object-fit:cover;border-radius:16px;margin:0 auto 1.5rem;box-shadow:0 8px 24px rgba(0,0,0,.1);">';
            html += '<div style="font-size:1.3rem;font-weight:800;margin-bottom:.3rem;">' + chosen.title + '</div>';
            if (price > 0) html += '<div style="font-size:1.1rem;font-weight:800;color:#111;margin-bottom:.3rem;">' + (price / 100).toFixed(2) + ' EUR</div>';
            if (filterType !== 'all') html += '<div style="font-size:.85rem;color:#888;margin-bottom:1.5rem;">' + filterValue + '</div>';
            if (inWishlist) html += '<div style="font-size:.75rem;color:#8CD300;margin-bottom:.5rem;">Gia nella tua wishlist</div>';
            html += '<div style="display:flex;gap:.5rem;justify-content:center;flex-wrap:wrap;max-width:400px;margin:0 auto;">';
            html += '<a href="' + productUrl + '" class="wl-btn wl-btn--primary" style="flex:1;">Vedi Prodotto</a>';
            if (variantId) html += '<button style="flex:1;background:#F4C430;color:#111;border:none;font-weight:800;border-radius:8px;padding:.6rem 1rem;font-size:.85rem;cursor:pointer;" onclick="addToCart(\'' + variantId + '\', this)">Aggiungi al carrello</button>';
            html += '</div>';
            html += '<div style="display:flex;gap:.5rem;justify-content:center;margin-top:1rem;max-width:400px;margin:1rem auto 0;">';
            if (!inWishlist) html += '<button class="wl-btn wl-btn--ghost" style="flex:1;" onclick="addToWishlist(\'' + chosen.id + '\');this.innerHTML=\'Aggiunto!\';this.disabled=true;">Salva in wishlist</button>';
            html += '<button class="wl-btn wl-btn--ghost" onclick="spinDestiny(\'' + filterType + '\',\'' + (filterValue || '').replace(/'/g,'') + '\')" style="flex:1;">Ritira</button>';
            html += '<button class="wl-btn wl-btn--ghost" onclick="loadDestinyOptions()" style="flex:1;">Cambia filtro</button>';
            html += '</div></div>';
            result.innerHTML = html;
          })
          .catch(function() {
            // Fallback senza variant
            var productUrl = '/products/' + chosen.handle;
            result.innerHTML = '<div style="text-align:center;padding:2rem 0;"><div style="font-size:1.3rem;font-weight:800;margin-bottom:1rem;">' + chosen.title + '</div><a href="' + productUrl + '" class="wl-btn wl-btn--primary">Vedi Prodotto</a><div style="margin-top:1rem;"><button class="wl-btn wl-btn--ghost" onclick="spinDestiny(\'' + filterType + '\',\'' + (filterValue || '').replace(/'/g,'') + '\')">Ritira</button></div></div>';
          });
        }
      }, 80 + (spinCount * 15));
    })
    .catch(function() {
      result.innerHTML = '<div style="text-align:center;padding:2rem;color:#888;">Errore nella ricerca</div><div style="text-align:center;"><button class="wl-btn wl-btn--ghost" onclick="loadDestinyOptions()">Riprova</button></div>';
    });
  };

  // ============================================================
  // SUGGERIMENTI (Potrebbe piacerti anche) via Recommendations API
  // ============================================================
  function loadSuggested() {
    var grid = document.getElementById('wlSuggestedGrid');
    if (!grid) return;
    var pageData = window.__wishlistPage;
    if (!pageData || !pageData.products || pageData.products.length === 0) {
      grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:1rem;color:#888;">Aggiungi giochi alla wishlist per ricevere suggerimenti</div>';
      return;
    }

    var wishlistIds = state.items.map(String);
    // Prendi recommendations da 3 prodotti random della wishlist
    var sources = pageData.products.slice().sort(function() { return Math.random() - 0.5; }).slice(0, 3);
    var allRecs = [];
    var fetched = 0;

    sources.forEach(function(src) {
      fetch('/recommendations/products.json?product_id=' + src.id + '&limit=10')
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (data.products) {
          data.products.forEach(function(p) {
            // Escludi prodotti in wishlist, non disponibili e sotto 10 EUR
            if (wishlistIds.indexOf(String(p.id)) === -1 && p.available && p.price >= 1000) {
              // Evita duplicati
              var isDup = allRecs.some(function(r) { return r.id === p.id; });
              if (!isDup) allRecs.push(p);
            }
          });
        }
      })
      .catch(function() {})
      .finally(function() {
        fetched++;
        if (fetched === sources.length) renderSuggested(grid, allRecs);
      });
    });
  }

  function renderSuggested(grid, products) {
    if (products.length === 0) {
      grid.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:1rem;color:#888;">Nessun suggerimento disponibile</div>';
      return;
    }
    // Mostra max 6, shuffled
    var toShow = products.sort(function() { return Math.random() - 0.5; }).slice(0, 6);
    var html = '';
    toShow.forEach(function(p) {
      var imgUrl = p.featured_image || (p.images && p.images[0]) || '';
      if (imgUrl && imgUrl.indexOf('//') === 0) imgUrl = 'https:' + imgUrl;
      var productUrl = '/products/' + p.handle;
      html += '<div class="wl-card">';
      html += '<a href="' + productUrl + '" class="wl-card__media">';
      if (imgUrl) html += '<img src="' + imgUrl + '" alt="' + (p.title || '').replace(/"/g, '') + '" loading="lazy">';
      html += '</a>';
      html += '<div class="wl-card__info">';
      html += '<a href="' + productUrl + '" class="wl-card__title">' + p.title + '</a>';
      html += '<div class="wl-card__price"><span>' + (p.price / 100).toFixed(2) + ' EUR</span></div>';
      html += '<div class="wl-card__footer">';
      html += '<button class="wl-btn wl-btn--ghost wl-btn--sm" data-wishlist-btn data-product-id="' + p.id + '" style="flex:1;">Salva</button>';
      html += '<a href="' + productUrl + '" class="wl-btn wl-btn--ghost wl-btn--sm" style="flex:0;">';
      html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>';
      html += '</a></div></div></div>';
    });
    grid.innerHTML = html;
  }


  // Scroll to section
  window.scrollToSection = function(id) {
    var el = document.getElementById(id);
    if (el) {
      var offset = 80; // header sticky height
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: 'smooth' });
    }
  };

  // ============================================================
  // TOAST
  // ============================================================
  // ============================================================
  // LOGIN PROMPT (per utenti non loggati)
  // ============================================================
  function showWishlistLoginPrompt() {
    var existing = document.getElementById('wlLoginPrompt');
    if (existing) existing.remove();

    var overlay = document.createElement('div');
    overlay.id = 'wlLoginPrompt';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:99999;display:flex;align-items:center;justify-content:center;padding:1rem;';
    overlay.onclick = function(e) { if (e.target === overlay) overlay.remove(); };

    var returnUrl = encodeURIComponent(window.location.pathname);

    overlay.innerHTML = '<div style="background:#fff;border-radius:16px;max-width:380px;width:100%;padding:2rem;text-align:center;box-shadow:0 20px 60px rgba(0,0,0,.2);position:relative;">'
      + '<button onclick="this.closest(\'#wlLoginPrompt\').remove()" style="position:absolute;top:12px;right:14px;background:none;border:none;font-size:1.4rem;color:#999;cursor:pointer;line-height:1;">&times;</button>'
      + '<div style="margin-bottom:1rem;">'
      + '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="48" height="48" fill="#e63946" stroke="none" style="margin:0 auto;"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>'
      + '</div>'
      + '<h3 style="margin:0 0 .5rem;font-size:1.15rem;font-weight:800;color:#111;">Salva i tuoi giochi preferiti</h3>'
      + '<p style="margin:0 0 1.25rem;font-size:.85rem;color:#666;line-height:1.5;">Accedi al tuo account per creare la tua wishlist e ricevere notifiche quando i prezzi scendono o i giochi tornano disponibili.</p>'
      + '<a href="/account/login?return_url=' + returnUrl + '" style="display:block;background:#F4C430;color:#111;font-weight:800;padding:.75rem 1.5rem;border-radius:10px;text-decoration:none;font-size:.95rem;margin-bottom:.75rem;transition:background .15s;">Accedi al tuo account</a>'
      + '<a href="/account/register?return_url=' + returnUrl + '" style="display:block;color:#666;font-size:.82rem;text-decoration:underline;">Non hai un account? Registrati</a>'
      + '</div>';

    document.body.appendChild(overlay);
  }

  function showWlToast(msg) {
    var existing = document.querySelector('.wl-toast');
    if (!existing) {
      existing = document.createElement('div');
      existing.className = 'wl-toast';
      document.body.appendChild(existing);
    }
    existing.textContent = msg;
    existing.classList.add('show');
    setTimeout(function() { existing.classList.remove('show'); }, 2500);
  }

  // ============================================================
  // TRENDING SECTIONS (carica dal Worker)
  // ============================================================
  function loadTrendingSection(containerId, days) {
    var container = document.getElementById(containerId);
    if (!container) return;

    function renderTrending(data) {
      if (!data.products || data.products.length === 0) return false;
        // Mostra max 6 prodotti, escludi quelli già in wishlist
        var shown = 0;
        var html = '';
        data.products.forEach(function(p) {
          if (shown >= 6) return;
          if (isInWishlist(p.id)) return;
          shown++;
          var price = p.price ? parseFloat(p.price).toFixed(2) : '0.00';
          html += '<div class="wl-card">';
          html += '<a href="/products/' + p.handle + '" class="wl-card__media">';
          if (p.image) html += '<img src="' + p.image + '" alt="" loading="lazy">';
          html += '</a>';
          html += '<div class="wl-card__info">';
          html += '<a href="/products/' + p.handle + '" class="wl-card__title">' + p.title + '</a>';
          html += '<div class="wl-card__price"><span>' + price + ' EUR</span></div>';
          html += '<div style="font-size:.72rem;color:#e63946;font-weight:600;margin-bottom:.5rem;display:flex;align-items:center;gap:4px;">';
          html += '<svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
          html += p.count + (p.count === 1 ? ' Frogger lo segue' : ' Froggers lo seguono');
          html += '</div>';
          html += '<div class="wl-card__footer">';
          html += '<button class="wl-btn wl-btn--ghost wl-btn--sm" data-wishlist-btn data-product-id="' + p.id + '" style="flex:1;">';
          html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" style="margin-right:4px;"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
          html += ' Salva</button>';
          html += '<a href="/products/' + p.handle + '" class="wl-btn wl-btn--ghost wl-btn--sm" style="flex:0;">';
          html += '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></a>';
          html += '</div></div></div>';
        });
      if (shown === 0) {
        container.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:2rem;color:#aaa;">Tutti i prodotti trending sono gia nella tua wishlist!</div>';
      } else {
        container.innerHTML = html;
      }
      return true;
    }

    fetch(WORKER_URL + '/api/public/trending?period=' + days)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        if (!renderTrending(data)) {
          // Fallback: se il periodo non ha dati, carica il trending totale
          return fetch(WORKER_URL + '/api/public/trending?period=all')
            .then(function(r2) { return r2.json(); })
            .then(function(allData) {
              if (!renderTrending(allData)) {
                container.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:2rem;color:#aaa;">Nessun dato disponibile</div>';
              }
            });
        }
      })
      .catch(function() {
        container.innerHTML = '<div style="grid-column:1/-1;text-align:center;padding:2rem;color:#aaa;">Errore caricamento</div>';
      });
  }

  // ============================================================
  // LOAD FULL WISHLIST (supera limite 50 di Liquid)
  // ============================================================
  function loadFullWishlist() {
    if (!state.customerId) return;
    // Gira anche sulle pagine prodotto/collezione (dove ci sono i cuori wishlist), non solo nella
    // pagina wishlist: così lo stato "già in wishlist" è corretto anche per i giochi oltre il
    // limite di 50 elementi che Liquid restituisce (partial: true).
    if (!document.getElementById('wlGrid') && !document.querySelector('[data-wishlist-btn]')) return;

    // Se Liquid ha gia tutti i prodotti, non serve
    var pageData = window.__wishlistPage;
    var liquidCount = pageData ? pageData.products.length : 0;
    var totalCount = state.items.length;

    // Sempre carica dal Worker per avere la lista completa e aggiornata
    fetch(WORKER_URL + '/api/public/my-wishlist', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: String(state.customerId) })
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (!data.products || data.products.length === 0) return;

      // Aggiorna stato con lista completa
      state.items = data.products.map(function(p) { return String(p.id); });
      updateUI(); // aggiorna anche i cuori (updateAllButtons), non solo il contatore

      // Aggiorna pageData.products con i dati completi dal worker (inclusi tags e vendor)
      var pageData = window.__wishlistPage;
      if (pageData) {
        pageData.products = data.products.map(function(p) {
          // Worker restituisce price come float (49.99), Liquid come centesimi (4999)
          // Normalizziamo in centesimi per coerenza
          var priceVal = p.price < 1000 ? Math.round(p.price * 100) : p.price;
          var compareVal = p.comparePrice ? (p.comparePrice < 1000 ? Math.round(p.comparePrice * 100) : p.comparePrice) : 0;
          return {
            id: String(p.id),
            title: p.title,
            url: '/products/' + p.handle,
            handle: p.handle,
            price: priceVal,
            comparePrice: compareVal,
            available: p.available,
            image: p.image,
            variantId: p.variantId ? String(p.variantId) : '',
            tags: p.tags || [],
            vendor: p.vendor || ''
          };
        });
      }

      // Aggiorna data-product-order e data-product-stock sulle card esistenti
      var orderIdx = data.products.length;
      document.querySelectorAll('[data-wl-card]').forEach(function(card) {
        var pid = card.dataset.productId;
        var productInList = data.products.findIndex(function(p) { return String(p.id) === pid; });
        if (productInList > -1) {
          card.setAttribute('data-product-order', String(data.products.length - productInList));
          card.setAttribute('data-product-stock', String(data.products[productInList].inventory >= 0 ? data.products[productInList].inventory : 999));
          card.setAttribute('data-product-price', String(data.products[productInList].price));
          card.setAttribute('data-product-available', String(data.products[productInList].available));
          var savePct = data.products[productInList].comparePrice > 0 ? Math.round((1 - data.products[productInList].price / data.products[productInList].comparePrice) * 100) : 0;
          card.setAttribute('data-product-deal', String(savePct));
        }
      });
      setupWlHierarchy();

      // Trova prodotti che non sono gia renderizzati dal Liquid
      var existingIds = [];
      document.querySelectorAll('[data-wl-card]').forEach(function(card) {
        existingIds.push(card.dataset.productId);
      });

      var missingProducts = data.products.filter(function(p) {
        return !existingIds.includes(String(p.id));
      });

      if (missingProducts.length === 0) return;

      // Renderizza i prodotti mancanti (SOLO nella pagina wishlist, dove esiste #wlGrid).
      // Su collection/homepage/altre pagine i cuori sono gia aggiornati sopra (updateUI): qui usciamo
      // per evitare grid.appendChild su null.
      var grid = document.getElementById('wlGrid');
      if (!grid) return;
      missingProducts.forEach(function(p) {
        var savePct = p.comparePrice > 0 ? Math.round((1 - p.price / p.comparePrice) * 100) : 0;
        var card = document.createElement('div');
        card.className = 'wl-card' + (!p.available ? ' wl-card--oos' : '');
        card.setAttribute('data-wl-card', '');
        card.setAttribute('data-product-id', p.id);
        card.setAttribute('data-product-title', p.title);
        card.setAttribute('data-product-price', p.price);
        card.setAttribute('data-product-available', p.available);
        card.setAttribute('data-product-deal', savePct);
        card.setAttribute('data-product-stock', p.inventory >= 0 ? String(p.inventory) : '999');
        card.setAttribute('data-product-preorder', (p.tags && p.tags.indexOf('preordine') > -1) ? 'true' : 'false');
        card.setAttribute('data-product-order', String(data.products.length - data.products.indexOf(p)));

        var html = '';

        // Checkbox
        html += '<div class="wl-card__checkbox" onclick="toggleSelectCard(event, \'' + p.id + '\', \'' + p.variantId + '\')"></div>';

        // Badges
        html += '<div class="wl-card__badges">';
        if (!p.available) html += '<span class="wl-badge wl-badge--oos">Esaurito</span>';
        html += '</div>';

        // Actions top
        html += '<div class="wl-card__actions-top">';
        html += '<button class="wl-card__action-btn" onclick="openCardMenu(event, \'' + p.id + '\')" aria-label="Menu"><svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><circle cx="12" cy="5" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="12" cy="19" r="2"/></svg></button>';
        html += '<div class="wl-card__menu" id="menu-' + p.id + '"><button onclick="moveToList(\'' + p.id + '\')">Sposta in altra lista</button><button onclick="removeFromWishlist(\'' + p.id + '\')">Rimuovi</button></div>';
        html += '</div>';

        // Image
        html += '<a href="/products/' + p.handle + '" class="wl-card__media">';
        if (p.image) html += '<img src="' + p.image + '" alt="' + p.title + '" loading="lazy">';
        html += '</a>';

        // Discount banner
        if (savePct > 0) {
          var saving = (p.comparePrice - p.price).toFixed(2);
          html += '<div class="wl-card__discount">RISPARMI ' + saving + ' EUR (-' + savePct + '%)</div>';
        }

        // Info
        html += '<div class="wl-card__info">';
        html += '<a href="/products/' + p.handle + '" class="wl-card__title">' + p.title + '</a>';
        html += '<div class="wl-card__price">';
        if (savePct > 0) {
          html += '<span class="wl-card__price--sale">' + p.price.toFixed(2) + ' EUR</span>';
          html += '<span class="wl-card__price--compare">' + p.comparePrice.toFixed(2) + ' EUR</span>';
        } else {
          html += '<span>' + p.price.toFixed(2) + ' EUR</span>';
        }
        html += '</div>';

        // Inventory FOMO
        if (p.available && p.inventory > 0 && p.inventory <= 5) {
          html += '<div class="wl-card__stock wl-card__stock--low"><svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg> Solo ' + p.inventory + ' rimast' + (p.inventory === 1 ? 'o' : 'i') + '!</div>';
        } else if (p.available && p.inventory > 5) {
          html += '<div class="wl-card__stock wl-card__stock--available">Disponibile</div>';
        }

        // Footer
        html += '<div class="wl-card__footer">';
        if (p.available && p.variantId) {
          html += '<button class="wl-btn wl-btn--primary wl-btn--sm" onclick="addToCart(\'' + p.variantId + '\', this)"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="margin-right:2px;"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/></svg> Aggiungi</button>';
          html += '<a href="/products/' + p.handle + '" class="wl-btn wl-btn--ghost wl-btn--sm" style="flex:0;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></a>';
        } else {
          html += '<span class="wl-btn wl-btn--disabled wl-btn--sm">Non Disponibile</span>';
        }
        html += '<button class="wl-btn wl-btn--icon" onclick="removeFromWishlist(\'' + p.id + '\')" aria-label="Rimuovi"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg></button>';
        html += '</div></div>';

        card.innerHTML = html;
        grid.appendChild(card);
      });

      // Applica sort "recenti" di default
      sortWishlist('recent');
      setupWlHierarchy();

      // Ri-filtra per lista attiva (nasconde prodotti spostati in altre liste)
      var activeTab = document.querySelector('.wl-tab--active');
      if (activeTab) {
        var activeListAttr = activeTab.getAttribute('data-list');
        var activeListName = (activeListAttr === 'default') ? 'La mia lista' : activeListAttr;
        switchList(activeTab, activeListName);
      }

      // Aggiorna conteggio header con card visibili
      var visibleCards = 0;
      document.querySelectorAll('[data-wl-card]').forEach(function(c) {
        if (c.style.display !== 'none') visibleCards++;
      });

      updateWishlistPageCount();

      // Aggiorna contatori tab custom dal wishlist_data
      var pageData = window.__wishlistPage;
      if (pageData && pageData.wishlistData && pageData.wishlistData.lists) {
        pageData.wishlistData.lists.forEach(function(list) {
          if (list.name === 'La mia lista') return;
          var tab = document.querySelector('.wl-tab[data-list="' + list.name + '"]');
          if (tab) {
            var cs = tab.querySelector('.wl-tab__count');
            if (cs) cs.textContent = list.products ? list.products.length : 0;
          }
        });
      }

      // Header pagina
      var totalCards = document.querySelectorAll('[data-wl-card]').length;
      var headerCount = document.querySelector('.wl-header__count');
      if (headerCount) headerCount.textContent = totalCards + ' gioch' + (totalCards === 1 ? 'io salvato' : 'i salvati');

      // Icona cuore header sito
      updateCounter();
    })
    .catch(function(err) { console.error('[Wishlist] loadFullWishlist error:', err); });
  }

  // ============================================================
  // VIEW SWITCHING
  // ============================================================
  var currentView = 'lista';
  var viewsLoaded = {};

  window.switchView = function(el, viewName) {
    // Aggiorna nav
    document.querySelectorAll('.wl-viewnav__btn').forEach(function(b) { b.classList.remove('wl-viewnav__btn--active'); });
    el.classList.add('wl-viewnav__btn--active');

    // Mostra vista
    document.querySelectorAll('.wl-view').forEach(function(v) { v.classList.remove('wl-view--active'); });
    var view = document.getElementById('view-' + viewName);
    if (view) view.classList.add('wl-view--active');

    currentView = viewName;

    // Carica contenuto lazy
    if (viewName === 'scopri' && !viewsLoaded.scopri) {
      viewsLoaded.scopri = true;
      // "I piu desiderati" e ora la section server-side frog-most-wanted (si auto-inizializza).
      loadSuggested();
    }
    if (viewName === 'carrello' && !viewsLoaded.carrello) {
      viewsLoaded.carrello = true;
      loadSmartCart();
    }
    if (viewName === 'destino' && !viewsLoaded.destino) {
      viewsLoaded.destino = true;
      loadDestinyOptions();
    }
    if (viewName === 'radar' && window.RadarPage) {
      window.RadarPage.onShow();
    }

    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // ============================================================
  // INIT
  // ============================================================
  function init() {
    updateUI();
    initListTabs();

    // Filtra "La mia lista" al caricamento se ci sono liste custom con prodotti
    var pageData = window.__wishlistPage;
    if (pageData && pageData.wishlistData && pageData.wishlistData.lists) {
      var hasCustomListProducts = pageData.wishlistData.lists.some(function(l) {
        return l.name !== 'La mia lista' && l.products && l.products.length > 0;
      });
      if (hasCustomListProducts) {
        var defaultTab = document.querySelector('.wl-tab[data-list="default"]');
        if (defaultTab) switchList(defaultTab, 'La mia lista');
      }
    }

    loadFullWishlist();
    setupWlHierarchy();
    loadWlNews();
    checkWlAlert(); // pallino "novità" sul cuore header (sitewide)

    // View nav listeners (evita interferenze Swym)
    document.querySelectorAll('.wl-viewnav__btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        switchView(btn, btn.dataset.view);
      }, true);
    });

    // Generate combo button
    var comboBtn = document.getElementById('generateComboBtn');
    if (comboBtn) {
      comboBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        generateRandomCombo();
      });
    }
  }

  // ============================================================
  // P0 — Gerarchia lista: filtri per stato + barra azione aggregata
  // (il filtro stato agisce via CSS su #wlGrid[data-sf], così compone
  //  in AND con lista/ricerca senza toccarne la logica)
  // ============================================================
  var wlNews = [];
  function wlEuro(v) { var n = parseFloat(v || 0); return n.toFixed(2).replace('.', ',') + ' €'; }
  function wlNewsFor(pid) {
    for (var i = 0; i < wlNews.length; i++) { if (String(wlNews[i].productId) === String(pid)) return wlNews[i]; }
    return null;
  }
  function loadWlNews() {
    if (!state.customerId || !document.getElementById('wlGrid')) return;
    fetch(WORKER_URL + '/api/public/wishlist-news', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: String(state.customerId) })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        wlNews = (d && d.news) || [];
        setupWlHierarchy();
        // Sei nella wishlist: le novità si considerano viste → spegni il pallino header
        if (d && d.unseen > 0) markWlNewsSeen();
      })
      .catch(function () {});
  }
  function classifyWlCards() {
    document.querySelectorAll('[data-wl-card]').forEach(function (c) {
      var avail = c.dataset.productAvailable === 'true';
      var pre = c.dataset.productPreorder === 'true';
      var deal = parseFloat(c.dataset.productDeal || 0) > 0;
      var stock = parseInt(c.dataset.productStock || '999', 10);
      var low = avail && !pre && stock > 0 && stock <= 5;
      var n = wlNewsFor(c.dataset.productId);
      c.classList.toggle('is-oos', !avail);
      c.classList.toggle('is-coming', avail && pre);
      c.classList.toggle('is-avail', avail && !pre);
      c.classList.toggle('is-offer', avail && deal);
      c.classList.toggle('is-low', low);
      c.classList.toggle('is-fresh', !!n && (n.type === 'arrival' || n.type === 'restock') && avail);
    });
  }
  function annotateWlNews() {
    document.querySelectorAll('[data-wl-card]').forEach(function (c) {
      var old = c.querySelector('.wl-fresh'); if (old) old.remove();
      var n = wlNewsFor(c.dataset.productId); if (!n) return;
      var media = c.querySelector('.wl-card__media'); if (!media) return;
      var txt, cls;
      if (n.type === 'arrival') { txt = '✨ Ora disponibile'; cls = 'wl-fresh--new'; }
      else if (n.type === 'restock') { txt = '🔔 Tornato disponibile'; cls = 'wl-fresh--new'; }
      else if (n.type === 'price_drop') { txt = '🔥 Sceso' + (n.prevPrice > 0 ? ' da ' + wlEuro(n.prevPrice) : ''); cls = 'wl-fresh--drop'; }
      else return;
      var el = document.createElement('div');
      el.className = 'wl-fresh ' + cls;
      el.textContent = txt;
      media.appendChild(el);
    });
  }
  function buildWlStateFilter() {
    var host = document.getElementById('wlStateFilter');
    if (!host) return;
    var grid = document.getElementById('wlGrid');
    var cur = (grid && grid.getAttribute('data-sf')) || 'all';
    function cnt(cls) { return document.querySelectorAll('[data-wl-card].' + cls).length; }
    var defs = [
      { k: 'all', label: 'Tutti', n: document.querySelectorAll('[data-wl-card]').length },
      { k: 'fresh', label: '✨ Da poco disponibili', n: cnt('is-fresh') },
      { k: 'offer', label: '🔥 In offerta', n: cnt('is-offer') },
      { k: 'avail', label: '🐸 Disponibili', n: cnt('is-avail') },
      { k: 'low', label: '⏳ Ultimi pezzi', n: cnt('is-low') },
      { k: 'oos', label: '🔔 Esauriti', n: cnt('is-oos') },
      { k: 'coming', label: '🗓️ In arrivo', n: cnt('is-coming') }
    ];
    host.innerHTML = defs.filter(function (d) { return d.k === 'all' || d.n > 0; }).map(function (d) {
      return '<button type="button" class="wl-chip' + (cur === d.k ? ' is-on' : '') + '" data-sf="' + d.k + '">' + d.label + ' <span class="wl-chip__n">' + d.n + '</span></button>';
    }).join('');
    host.querySelectorAll('[data-sf]').forEach(function (b) {
      b.addEventListener('click', function () { window.filterWlState(b.getAttribute('data-sf')); });
    });
  }
  window.filterWlState = function (k) {
    var grid = document.getElementById('wlGrid');
    if (!grid) return;
    grid.setAttribute('data-sf', k);
    document.querySelectorAll('#wlStateFilter .wl-chip').forEach(function (b) {
      b.classList.toggle('is-on', b.getAttribute('data-sf') === k);
    });
  };
  // --- Pallino "novità" sul cuore in header (sitewide) ---
  function setWlHeartAlert(on) {
    var dot = document.querySelector('[data-wl-alert]');
    var heart = document.querySelector('[data-wl-heart]');
    if (dot) { if (on) dot.removeAttribute('hidden'); else dot.setAttribute('hidden', ''); }
    if (heart) heart.classList.toggle('wl-has-alert', !!on);
  }
  function checkWlAlert() {
    if (!state.customerId || !document.querySelector('[data-wl-alert]')) return;
    try {
      var ts = parseInt(sessionStorage.getItem('wlAlertTs') || '0', 10);
      if (Date.now() - ts < 300000) { setWlHeartAlert(sessionStorage.getItem('wlAlertUnseen') === '1'); return; }
    } catch (e) {}
    fetch(WORKER_URL + '/api/public/wishlist-news', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: String(state.customerId) })
    })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var on = !!(d && d.unseen > 0);
        try { sessionStorage.setItem('wlAlertUnseen', on ? '1' : '0'); sessionStorage.setItem('wlAlertTs', String(Date.now())); } catch (e) {}
        setWlHeartAlert(on);
      })
      .catch(function () {});
  }
  function markWlNewsSeen() {
    if (!state.customerId) return;
    try { sessionStorage.setItem('wlAlertUnseen', '0'); sessionStorage.setItem('wlAlertTs', String(Date.now())); } catch (e) {}
    setWlHeartAlert(false);
    fetch(WORKER_URL + '/api/public/wishlist-news-seen', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: String(state.customerId) })
    }).catch(function () {});
  }
  function buildWlActionBar() {
    var bar = document.getElementById('wlActionBar');
    if (!bar) return;
    if (sessionStorage.getItem('wlBarDismissed') === '1') { bar.style.display = 'none'; return; }
    var fresh = document.querySelectorAll('[data-wl-card].is-fresh').length;
    var offers = document.querySelectorAll('[data-wl-card].is-offer').length;
    var low = document.querySelectorAll('[data-wl-card].is-low').length;
    if (!fresh && !offers && !low) { bar.style.display = 'none'; return; }
    var parts = [];
    if (fresh) parts.push('<strong>' + fresh + ' ora disponibil' + (fresh === 1 ? 'e' : 'i') + '</strong>');
    if (offers) parts.push(offers + ' in offerta');
    if (low) parts.push(low + ' agli ultimi pezzi');
    var target = fresh ? 'fresh' : (offers ? 'offer' : 'low');
    bar.className = 'wl-actionbar' + (fresh ? ' wl-actionbar--fresh' : '');
    bar.innerHTML =
      '<span class="wl-actionbar__ic">' + (fresh ? '✨' : '🔥') + '</span>' +
      '<span class="wl-actionbar__t">' + parts.join(' · ') + '</span>' +
      '<button type="button" class="wl-actionbar__cta" data-act="' + target + '">' + (fresh ? 'Vedi cosa è arrivato' : 'Vedi le offerte') + '</button>' +
      '<button type="button" class="wl-actionbar__x" aria-label="Chiudi">&times;</button>';
    bar.style.display = '';
    bar.querySelector('[data-act]').addEventListener('click', function () { window.filterWlState(target); });
    bar.querySelector('.wl-actionbar__x').addEventListener('click', function () {
      sessionStorage.setItem('wlBarDismissed', '1'); bar.style.display = 'none'; markWlNewsSeen();
    });
  }
  function setupWlHierarchy() {
    var grid = document.getElementById('wlGrid');
    if (!grid) return;
    if (!grid.getAttribute('data-sf')) grid.setAttribute('data-sf', 'all');
    classifyWlCards();
    annotateWlNews();
    buildWlStateFilter();
    buildWlActionBar();
  }
  window.setupWlHierarchy = setupWlHierarchy;

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

})();
